import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children, permission, role }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-background" data-testid="auth-loading">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/dashboard" replace />;
  if (permission && !(user.permissions || []).includes(permission)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
